import React from "react";
//#region redux
import { useDispatch, useSelector } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
import { AppState } from "store";
//#endregion
//#region types
import { FormFieldConstants } from "utils/constants";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { StyledButton } from "components/common";
import { useSupportTicketCreateDialog } from "components/support";
import { useLocation, useNavigate } from "react-router-dom";
//#endregion
import { DateHelper, LocalizationHelperInstance, QueryStateHelper, UrlHelper, UtilsHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const RevisorFAQWidgetFooter: React.FC = (props) => {
  const dispatch = useDispatch();
  const { getDialog: getSupportTicketCreateDialog } = useSupportTicketCreateDialog();

  const onOpenSupportTicket = () => {
    dispatch(displayDialog(getSupportTicketCreateDialog()));
  };

  const annualAccountsFinancialYear = useSelector(
    (store: AppState) => store.auth.selectedCompany.annualAccountsFinancialYear
  );

  const location = useLocation();
  const navigate = useNavigate();

  const navigateToSupportCases = () => {
    const queryEncoder = QueryStateHelper.dateRangeQueryEncoder(FormFieldConstants.Support.Filter.Created);
    const searchParams = new URLSearchParams("");

    if (annualAccountsFinancialYear) {
      queryEncoder.urlEncode(searchParams, undefined, {
        start: DateHelper.addDays(new Date(annualAccountsFinancialYear.end), 1),
      });
    }

    const searchQuery = searchParams?.toString();
    navigate(UrlHelper.formatPath(`/Support${!UtilsHelper.isEmpty(searchQuery) ? `?${searchQuery}` : ""}`), {
      state: { background: location },
    });
  };

  return (
    <Grid container className={cssExports.revisorFaqFooter} rowGap={2}>
      <Grid container item rowGap={0.5}>
        <Grid item xs={12} className={cssExports.revisorFaqFooterTitle}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.ContactUs)}
        </Grid>
        <Grid item xs={12} className={cssExports.revisorFaqFooterText}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.ContactUsText)}
        </Grid>
      </Grid>
      <Grid container item direction="row" columnGap={1}>
        <StyledButton size="xs" onClick={onOpenSupportTicket}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.CreateSupportCase)}
        </StyledButton>
        <StyledButton secondary size="xs" onClick={navigateToSupportCases}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.ViewCases)}
        </StyledButton>
      </Grid>
    </Grid>
  );
};

export default RevisorFAQWidgetFooter;
